import {Input} from '../elements/index';
import {IconNewsletterArrow} from '../icons/IconNewsletterArrow';
import {useState} from 'react';
import clsx from 'clsx';
import {ANALYTIC_EVENT_NAMES} from '~/lib/const';
import {ClientAnalytics} from '@shopify/hydrogen';

const KLAVIYO_API_URL = import.meta.env.PUBLIC_KLAVIYO_API_URL;
const KLAVIYO_API_KEY = import.meta.env.PUBLIC_KLAVIYO_API_KEY;
const KLAVIYO_API_LIST_ID = import.meta.env.PUBLIC_KLAVIYO_API_LIST_ID;
const KLAVIYO_API_REVISION = import.meta.env.PUBLIC_KLAVIYO_API_REVISION;

let timeoutID: NodeJS.Timeout | undefined = undefined;

export function FooterNewsletter() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const onClickSendNewsletter = async () => {
    if (loading) {
      return;
    }

    if (!email || email.length === 0) {
      setError('ENTER YOUR EMAIL ADDRESS');
      return;
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError('ENTER VALID EMAIL ADDRESS');
      return;
    }

    const body = JSON.stringify({
      data: {
        type: 'subscription',
        attributes: {
          list_id: KLAVIYO_API_LIST_ID,
          email,
        },
      },
    });

    setLoading(true);
    setError('');
    setSuccess(false);

    try {
      ClientAnalytics.publish(ANALYTIC_EVENT_NAMES.EMAIL_SIGNUP, true, {
        event: {
          _clear: true,
          event: ANALYTIC_EVENT_NAMES.EMAIL_SIGNUP,
        },
      });

      const response = await fetch(
        `${KLAVIYO_API_URL}?company_id=${KLAVIYO_API_KEY}`,
        {
          method: 'POST',
          headers: {
            revision: KLAVIYO_API_REVISION,
            'Content-Type': 'application/json',
          },
          body,
        },
      );

      if (response.status === 202) {
        setSuccess(true);

        timeoutID = setTimeout(() => {
          setEmail('');
          setSuccess(false);
        }, 5000);
      } else {
        setError('SOMETHING WENT WRONG. PLEASE TRY AGAIN.');
      }
    } catch {
      setError('SOMETHING WENT WRONG. PLEASE TRY AGAIN.');
    }

    setLoading(false);
  };

  return (
    <div className="flex flex-col">
      <span className="text-base xl:text-2lg font-extrabold font-header">
        SIGN UP FOR EXCLUSIVE DEALS
      </span>

      <div className="relative mt-5 xl:mt-[25px]">
        <Input
          variant="newsletter"
          placeholder="Enter your email address"
          className={clsx('pr-11 peer', {
            'border-red-400 focus:border-red-400': error,
          })}
          value={email}
          onChange={(e) => {
            clearTimeout(timeoutID);
            setEmail(e.target.value);
            setError('');
            setSuccess(false);
          }}
          disabled={loading}
        />

        {loading ? (
          <div className="flex items-center justify-center absolute right-[23px] top-1/2 -translate-y-1/2">
            <div className="w-4 h-4 border-b-2 border-gray-400 rounded-full animate-spin"></div>
          </div>
        ) : (
          <IconNewsletterArrow
            className={clsx(
              'absolute right-[23px] top-1/2 -translate-y-1/2 text-gray-400 peer-focus:text-blue-500 hover:cursor-pointer',
            )}
            onClick={() => onClickSendNewsletter()}
          />
        )}
      </div>
      {error && (
        <span className="mt-2.5 text-14/16 font-header font-bold text-red-400">
          {error}
        </span>
      )}
      {success && (
        <span className="mt-2.5 text-14/16 font-header font-bold text-blue-500">
          THANKS FOR SUBMITTING YOUR EMAIL
        </span>
      )}
    </div>
  );
}
